const questionTypes = (type) => {

    switch(type) {
        case 'scale':
            return 'Schaalvraag';
        case 'multiple-one':
            return 'Meerkeuze vraag met één mogelijk antwoord';
        case 'multiple-multiple':
            return 'Meerkeuze vraag met meerdere mogelijke antwoorden';
        case 'paragraph':
            return 'Open vraag';
        case 'number':
            return 'Numerieke vraag';
        case 'matrix-one':
            return 'Matrix vraag met één mogelijk antwoord';
        case 'matrix-multiple':
            return 'Matrix vraag met meerdere mogelijke antwoorden';
        default:
            return type;
    }

}

export default questionTypes;